module.exports = __webpack_public_path__ + "static/media/myprofile.eedbf5ad.png";